module.exports = __webpack_public_path__ + "img/img5.0c2fe8fc.png";